import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}));
//# sourceMappingURL=InputTitle.styles.js.map